/*
* @requires  zxq3-websocket.js
*/

var HebcaMiddleware = HebcaMiddleware || {};
(function($m) {

    /**
     * @param param
     * {
     *     success:
     *     fail:
     * }
     * @constructor
     */
    function ZXQ3(param) {
        //根据当前浏览器环境，自动判断采用哪种实现。目前仅支持websocket
        this.imp=new $m.ZXQ3Websocket(param,this,this._eventHandler);
        this.middleware=null;
        this.eventBus={};
        //this.imp.setEventCallback(this,this._eventHandler);
    }

    /**
     * PDF签字
     * @param param
     * {
     *      pdfFileIn	string	否	待签名PDF文件路径
     *      pdfFileOut	string	否	签名完毕后pdf文件路径
     *      pdfUrlDownload	string	否	待签名PDF下载路径，pdfFileIn和pdfUrlDownload二者选一
     *      pdfUrlUpload	string	否	签名完毕后pdf上传文件路径，如果pdfFileOut和pdfUrlUpload二者选一，如果都不存在，则采用pdfFileIn作为文件的输出，会导致覆盖pdfFileIn文件
     *      pdfName	string	否	pdf文件名称
     *      signType	int	否	采集方式 1=仅采集手写 2=仅采集指纹 3=采集手写和指纹 默认为3
     *      signFlag	int	否	签署类型 0：单签 1： 批量 2： 多页 3： 删除印章 默认为0
     *      fpTimes	int	否	指纹采集次数，默认为1
     *      page	int	否	盖章的页
     *      pageRange	数组	否	盖章起始和终止页，如：[1,10].仅用于多页盖章
     *      pos	数组	否	盖章位置坐标，如：[100,100]
     *      signRecord	bool	否	是记录签名记录（签字指纹图片）,默认false
     *      success：成功时回调function(ret){}  ret对象包含： signRecord: 签字指纹图片Base64
     *      fail: function(e){}
     * }
     */
    ZXQ3.prototype.pdfSign=function (param) {
        this.imp.pdfSign(param);
    };

    /**
     * 打开URL
     * @param param
     * {
     *     url:	string	URL链接
     *     success：function(seal){}
     *     fail: function(e){}
     * }
     */
    ZXQ3.prototype.openUrl=function (param) {
        this.imp.openUrl(param);
    };

    /**
     * Web签名
     * @param param
     * {
     *      url	string	是	URL链接
     *      session	string	否	session字符串
     *      signType	int	否	采集方式 1=仅采集手写 2=仅采集指纹 3=采集手写和指纹 默认为3
     *      fpTimes	int	否	指纹采集次数，默认为1
     *     success：function(){}
     *     fail: function(e){}
     */
    ZXQ3.prototype.webSign=function (param) {
        this.imp.webSign(param);
    };

    /**
     * 开启屏幕共享
     * @param param
     * {
     *     success：function(){}
     *     fail: function(e){}
     */
    ZXQ3.prototype.startScreenShare=function (param) {
        this.imp.startScreenShare(param);
    };

    /**
     * 关闭屏幕共享
     * @param param
     * {
     *     success：function(){}
     *     fail: function(e){}
     */
    ZXQ3.prototype.stopScreenShare=function (param) {
        this.imp.stopScreenShare(param);
    };

    /**
     * 工牌展示
     * @param param
     * {
     *     success：function(){}
     *     fail: function(e){}
     */
    ZXQ3.prototype.showUser=function (param) {
        this.imp.showUser(param);
    };

    /**
     * 采集签名图片
     * @param param
     * {
     *     success：function(){}
     *     fail: function(e){}
     */
    ZXQ3.prototype.getSignImage=function (param) {
        this.imp.getSignImage(param);
    };

    /**
     * 读取身份证信息
     * @param param
     * {
     *     success：function(){}
     *     fail: function(e){}
     */
    ZXQ3.prototype.readIDCard=function (param) {
        this.imp.readIDCard(param);
    };

    /**
     * 人证核验
     * @param param
     * {
     *     success：function(){}
     *     fail: function(e){}
     */
    ZXQ3.prototype.compareManAndIDCard=function (param) {
        this.imp.compareManAndIDCard(param);
    };

    /**
     * 采集人像
     * @param param
     * {
     *     success：function(){}
     *     fail: function(e){}
     */
    ZXQ3.prototype.takePicture=function (param) {
        this.imp.takePicture(param);
    };

    /**
     * 录音
     * @param param
     * {
     *     success：function(){}
     *     fail: function(e){}
     */
    ZXQ3.prototype.recordSound=function (param) {
        this.imp.recordSound(param);
    };

    /**
     * 发送数据
     * @param param
     * {
     *     data	string	是	json数据
     *     success：function(){}
     *     fail: function(e){}
     */
    ZXQ3.prototype.sendData=function (param) {
        this.imp.sendData(param);
    };

    /**
     * 多PDF签字
     * @param param
     * {
     *      filesIn	string数组	是	输入的PDF文件
     *      filesOut	string数组	否	输出的PDF文件，如果为空，则覆盖输入文件
     *     success：function(){}
     *     fail: function(e){}
     */
    ZXQ3.prototype.multiPdfSign=function (param) {
        this.imp.multiPdfSign(param);
    };

    /**
     * 获取好差评信息
     * @param param
     * {
     *      obj	string	是	评价信息
     *      name	string	是	姓名
     *      id	string	是	编号
     *     image	string	是	照片
     *     success：function(){}
     *     fail: function(e){}
     */
    ZXQ3.prototype.getGrade=function (param) {
        this.imp.getGrade(param);
    };

    /**
     * 更新好差评信息
     * @param param
     * {
     *      obj	string	是	评价信息
     *     success：function(){}
     *     fail: function(e){}
     */
    ZXQ3.prototype.updateGradeInfo=function (param) {
        this.imp.updateGradeInfo(param);
    };

    /**
     * 获取设备信息
     * @param param
     * {
     *     success：function(deviceInfo){}
     *     fail: function(e){}
     */
    ZXQ3.prototype.getDeviceInfo=function (param) {
        this.imp.getDeviceInfo(param);
    };

    ZXQ3.prototype.startActivity=function (param) {
        this.imp.startActivity(param);
    };

    ZXQ3.prototype.getSecret=function (param) {
        this.imp.getSecret(param);
    };

    /**
     * 添加事件监听
     * @param param
     * {
     *     name: 事件名称，insertDevice
     *     callback： function(event){} 监听函数
     * }
     */
    ZXQ3.prototype.addEventListener=function(param){
        if(this.eventBus[param.name]){
            var find=false;
            for(var i=0;i<this.eventBus[param.name].length;i++){
                if(this.eventBus[param.name][i].callback===param.callback){
                    find=true;
                    break;
                }
            }
            if(!find){
                this.eventBus[param.name].push(param);
                return true;
            }
            else {
                return true;
            }
        }
        else{
            this.eventBus[param.name]=[];
            this.eventBus[param.name].push(param);
            return true;
        }
    };

    /**
     * 删除事件监听
     * @param param
     * {
     *     name: 事件名称
     *     callback:
     * }
     */
    ZXQ3.prototype.removeEventListener=function (param) {
        if(this.eventBus[param.name]) {
            for(var i=0;i<this.eventBus[param.name].length;i++){
                if(this.eventBus[param.name][i].callback===param.callback){
                    this.eventBus[param.name].splice(i,1)
                    return true;
                }
            }

            return false;
        }
        else{
            return false;
        }
    };

    ZXQ3.prototype._eventHandler=function(eventName,eventObject){
        $m.debug("event:",eventName,eventObject);

        if(this.eventBus[eventName]){
            for(var i=0;i<this.eventBus[eventName].length;i++){
                if(this.eventBus[eventName][i].callback){
                    this.eventBus[eventName][i].callback(eventName,eventObject);
                }
            }
        }
    };

    ZXQ3.prototype.close=function(){
        this.imp.close()
    };

    $m.ZXQ3=ZXQ3;

})(HebcaMiddleware);
